module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-down-right-139519bd.svg";